/**
 * Toy Vault Browser — Shop All product gallery (future-ready for category shelves).
 * Reuses Card Vault / Comic Archive selector + grid patterns.
 */
(function () {
  var VALID_VIEWS = { all: 1, categories: 1 };
  var PRODUCT_VIEWS = { all: 1 };
  var GRID_SECTION = 'mc-toy-vault-grid';
  var viewCache = Object.create(null);

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getParams() {
    try {
      return new URL(window.location.href).searchParams;
    } catch (e) {
      return new URLSearchParams();
    }
  }

  function readView(root) {
    var fromUrl = (getParams().get('vault') || getParams().get('view') || '').toLowerCase();
    if (VALID_VIEWS[fromUrl]) return fromUrl;
    return root.getAttribute('data-cab-default-view') || 'all';
  }

  function writeUrl(state, mode) {
    try {
      var url = new URL(window.location.href);
      Object.keys(state).forEach(function (key) {
        var value = state[key];
        if (key === 'view' && VALID_VIEWS[String(value || '').toLowerCase()]) {
          key = 'vault';
        }
        if (value === null || value === undefined || value === '') {
          url.searchParams.delete(key);
        } else {
          url.searchParams.set(key, value);
        }
      });
      var viewParam = (url.searchParams.get('view') || '').toLowerCase();
      if (!viewParam || VALID_VIEWS[viewParam]) {
        url.searchParams.set('view', 'toy-vault');
      }
      if (mode === 'push') history.pushState(state, '', url);
      else history.replaceState(state, '', url);
    } catch (e) {
      /* ignore */
    }
  }

  function announce(root, message) {
    var el = root.querySelector('[data-cab-announcer]');
    if (!el) return;
    el.textContent = '';
    window.setTimeout(function () {
      el.textContent = message;
    }, 10);
  }

  function moveIndicator(root) {
    var track = root.querySelector('[data-cab-tablist]');
    var indicator = root.querySelector('[data-cab-indicator]');
    var active = root.querySelector('[data-cab-tab].is-active');
    if (!track || !indicator || !active) return;
    var trackRect = track.getBoundingClientRect();
    var tabRect = active.getBoundingClientRect();
    var left = tabRect.left - trackRect.left + track.scrollLeft;
    indicator.style.width = tabRect.width + 'px';
    indicator.style.transform = 'translateX(' + left + 'px)';
    indicator.style.opacity = '1';
  }

  function scrollActiveTabIntoView(root) {
    var active = root.querySelector('[data-cab-tab].is-active');
    if (!active || typeof active.scrollIntoView !== 'function') return;
    active.scrollIntoView({
      behavior: prefersReducedMotion() ? 'auto' : 'smooth',
      inline: 'center',
      block: 'nearest'
    });
  }

  function updateScrollHint(root) {
    var wrap = root.querySelector('.cab-selector__track-wrap');
    var track = root.querySelector('[data-cab-tablist]');
    if (!wrap || !track) return;
    wrap.classList.toggle('is-scrollable', track.scrollWidth > track.clientWidth + 4);
  }

  function setTabState(root, view) {
    root.querySelectorAll('[data-cab-tab]').forEach(function (tab) {
      var isActive = tab.getAttribute('data-cab-view') === view;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.tabIndex = isActive ? 0 : -1;
      var selectedText = tab.querySelector('.cab-selector__selected-text');
      if (selectedText) selectedText.hidden = !isActive;
    });
    moveIndicator(root);
    scrollActiveTabIntoView(root);
  }

  function reinitLazyload(scope) {
    if (window.lazySizes && window.lazySizes.loader) {
      try {
        window.lazySizes.loader.checkElems();
      } catch (e) {
        /* ignore */
      }
    }
  }

  function applyShelf(root, view) {
    var shelf = VALID_VIEWS[view] ? view : 'all';
    var shelves = root.querySelector('[data-cv-shelves]');
    if (shelves) shelves.setAttribute('data-cv-active-shelf', shelf);
    root.querySelectorAll('[data-cv-shelf]').forEach(function (el) {
      el.hidden = el.getAttribute('data-cv-shelf') !== shelf;
    });
  }

  function showLoading(host, show) {
    var loading = host.querySelector('[data-cab-loading]');
    if (!loading) {
      if (show) {
        host.innerHTML =
          '<div class="cab-loading" data-cab-loading><p class="cab-loading__text">Opening the vault</p><div class="cab-loading__bar" aria-hidden="true"></div></div>';
      }
      return;
    }
    loading.hidden = !show;
  }

  function extractRemoteGrid(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var remote = doc.querySelector('[data-cab-remote-grid]');
    if (remote) return remote.innerHTML;
    var grid = doc.querySelector('[data-cab-grid]');
    return grid ? grid.outerHTML : '';
  }

  function bindGridControls(root, shelfEl, view) {
    if (!shelfEl || shelfEl._tvGridBound) return;
    shelfEl._tvGridBound = true;

    var sort = shelfEl.querySelector('[data-cab-sort]');
    if (sort) {
      sort.addEventListener('change', function () {
        loadGrid(root, view, { sort_by: sort.value, page: 1, history: 'push' });
      });
    }

    var pagination = shelfEl.querySelector('[data-cab-pagination]');
    if (pagination) {
      pagination.addEventListener('click', function (event) {
        var link = event.target.closest('[data-cab-page]');
        if (!link) return;
        event.preventDefault();
        var sortEl = shelfEl.querySelector('[data-cab-sort]');
        loadGrid(root, view, {
          page: link.getAttribute('data-cab-page'),
          sort_by: sortEl ? sortEl.value : undefined,
          history: 'push'
        });
      });
    }
  }

  function loadGrid(root, view, options) {
    options = options || {};
    if (!PRODUCT_VIEWS[view]) return Promise.resolve();

    var shelfEl = root.querySelector('[data-cv-shelf="' + view + '"]');
    if (!shelfEl) return Promise.resolve();
    if ((shelfEl.getAttribute('data-cv-shelf-mode') || 'products') !== 'products') {
      return Promise.resolve();
    }

    var collectionUrl = shelfEl.getAttribute('data-cv-collection-url') || '';
    if (!collectionUrl) return Promise.resolve();

    if (
      shelfEl.querySelector('[data-cab-grid]') &&
      !options.force &&
      !options.sort_by &&
      !options.page
    ) {
      bindGridControls(root, shelfEl, view);
      return Promise.resolve();
    }

    var sortBy = options.sort_by;
    if (sortBy === undefined) sortBy = getParams().get('sort_by') || '';
    var page = options.page || 1;
    var cacheKey = collectionUrl + '|v=' + view + '|s=' + sortBy + '|p=' + page;

    if (viewCache[cacheKey] && !options.force) {
      shelfEl.innerHTML = viewCache[cacheKey];
      shelfEl._tvGridBound = false;
      bindGridControls(root, shelfEl, view);
      reinitLazyload(shelfEl);
      return Promise.resolve();
    }

    if (root._tvGridAbort) root._tvGridAbort.abort();
    var controller = new AbortController();
    root._tvGridAbort = controller;

    var host = shelfEl.querySelector('[data-cv-lazy-grid]') || shelfEl;
    showLoading(host, true);

    var fetchUrl = new URL(collectionUrl, window.location.origin);
    fetchUrl.searchParams.set('section_id', GRID_SECTION);
    fetchUrl.searchParams.set('view', 'toy-vault');
    fetchUrl.searchParams.set('vault', view);
    if (sortBy) fetchUrl.searchParams.set('sort_by', sortBy);
    if (page && String(page) !== '1') fetchUrl.searchParams.set('page', String(page));

    return fetch(fetchUrl.toString(), {
      signal: controller.signal,
      credentials: 'same-origin',
      headers: { Accept: 'text/html' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Grid request failed');
        return res.text();
      })
      .then(function (html) {
        var markup = extractRemoteGrid(html);
        if (!markup) throw new Error('Empty grid');
        viewCache[cacheKey] = markup;
        shelfEl.innerHTML = markup;
        shelfEl.setAttribute('data-cv-collection-url', collectionUrl);
        shelfEl._tvGridBound = false;
        bindGridControls(root, shelfEl, view);
        reinitLazyload(shelfEl);
        if (options.history) {
          writeUrl(
            {
              vault: view,
              page: page && String(page) !== '1' ? String(page) : null,
              sort_by: sortBy || null
            },
            options.history
          );
        }
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        if (!shelfEl.querySelector('[data-cab-grid]')) {
          shelfEl.innerHTML =
            '<div class="cab-empty" role="status"><p class="cab-empty__text">This vault section is currently being catalogued.</p></div>';
        }
      })
      .then(function () {
        if (root._tvGridAbort === controller) root._tvGridAbort = null;
      });
  }

  function ensureProductShelf(root, view) {
    applyShelf(root, view);
    if (!PRODUCT_VIEWS[view]) return Promise.resolve();
    var shelfEl = root.querySelector('[data-cv-shelf="' + view + '"]');
    if (!shelfEl) return Promise.resolve();
    if (shelfEl.querySelector('[data-cab-grid]')) {
      bindGridControls(root, shelfEl, view);
      return Promise.resolve();
    }
    return loadGrid(root, view, { history: false, force: true });
  }

  function activateView(root, view, options) {
    options = options || {};
    if (!VALID_VIEWS[view]) view = 'all';
    if (view === 'categories' && !root.querySelector('[data-cv-shelf="categories"]')) {
      view = 'all';
    }

    root.setAttribute('data-cab-active-view', view);
    setTabState(root, view);
    announce(root, (view === 'all' ? 'Shop All' : 'Categories') + ' view');

    return ensureProductShelf(root, view).then(function () {
      if (options.history) {
        writeUrl(
          {
            vault: view,
            page: null,
            sort_by: PRODUCT_VIEWS[view] ? getParams().get('sort_by') || null : null
          },
          options.history
        );
      }
    });
  }

  function observeSticky(root) {
    var selector = root.querySelector('[data-cab-selector]');
    if (!selector || !selector.classList.contains('cab-selector--sticky')) return;
    if (!('IntersectionObserver' in window)) return;
    var sentinel = document.createElement('div');
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.cssText = 'position:relative;height:1px;margin:0';
    selector.parentNode.insertBefore(sentinel, selector);
    new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          selector.classList.toggle('is-stuck', !entry.isIntersecting);
        });
      },
      { rootMargin: '-1px 0px 0px 0px', threshold: 0 }
    ).observe(sentinel);
  }

  function initVault(root) {
    if (!root || root._tvBrowserBound) {
      if (root) {
        moveIndicator(root);
        updateScrollHint(root);
      }
      return;
    }
    root._tvBrowserBound = true;

    if (root._tvAbort) root._tvAbort.abort();
    var abort = new AbortController();
    root._tvAbort = abort;
    var signal = abort.signal;

    var serverView = root.getAttribute('data-cab-active-view') || 'all';
    var initialView = readView(root);
    observeSticky(root);
    updateScrollHint(root);

    var defaultSort = root.getAttribute('data-tv-default-sort') || '';
    if (defaultSort && !getParams().get('sort_by') && PRODUCT_VIEWS[initialView]) {
      writeUrl({ vault: initialView, sort_by: defaultSort }, 'replace');
    }

    if (initialView !== serverView) {
      activateView(root, initialView, { history: 'replace', focus: false });
    } else {
      setTabState(root, initialView);
      ensureProductShelf(root, initialView);
    }

    window.addEventListener(
      'resize',
      function () {
        moveIndicator(root);
        updateScrollHint(root);
      },
      { signal: signal, passive: true }
    );

    var track = root.querySelector('[data-cab-tablist]');
    if (track) {
      track.addEventListener(
        'scroll',
        function () {
          updateScrollHint(root);
        },
        { signal: signal, passive: true }
      );
    }

    root.querySelectorAll('[data-cab-tab]').forEach(function (tab) {
      tab.addEventListener(
        'click',
        function (event) {
          event.preventDefault();
          activateView(root, tab.getAttribute('data-cab-view'), { history: 'push' });
        },
        { signal: signal }
      );
    });

    window.addEventListener(
      'popstate',
      function () {
        activateView(root, readView(root), { history: false, focus: false });
      },
      { signal: signal }
    );

    window.requestAnimationFrame(function () {
      moveIndicator(root);
    });
  }

  function boot() {
    document.querySelectorAll('[data-toy-vault]').forEach(initVault);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector
      ? event.target.querySelector('[data-toy-vault]')
      : null;
    if (!root && event.target.matches && event.target.matches('[data-toy-vault]')) {
      root = event.target;
    }
    if (root) {
      root._tvBrowserBound = false;
      initVault(root);
    }
  });
})();
